import { render } from "./TablaPrestadosOrganismos.vue?vue&type=template&id=701d4893&ts=true"
import script from "./TablaPrestadosOrganismos.vue?vue&type=script&lang=ts"
export * from "./TablaPrestadosOrganismos.vue?vue&type=script&lang=ts"

import "./TablaPrestadosOrganismos.vue?vue&type=style&index=0&id=701d4893&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__